export default "__VITE_ASSET__vBeoL5g5__"